import * as React from "react"
import { Theme } from "@radix-ui/themes"
import "@radix-ui/themes/styles.css"
import "./styles/custom-accent.css"
import "./styles/global.css"

/**
 * Single source of truth for the Radix Themes provider. Re-exported from BOTH
 * gatsby-browser.tsx and gatsby-ssr.tsx — wrapRootElement is not auto-shared between them,
 * and only wrapping one side would render unwrapped HTML on the server (hydration mismatch).
 *
 * `appearance="inherit"` lets the .light/.dark class on <html> (set by the pre-body script
 * in gatsby-ssr.tsx) drive light/dark mode with no flash of the wrong theme.
 */
export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <Theme
    accentColor="crimson"
    grayColor="sand"
    radius="medium"
    scaling="100%"
    appearance="inherit"
  >
    {element}
  </Theme>
)
